// extracted by mini-css-extract-plugin
export default {"card":"TenantCard_card__JQhgK","description":"TenantCard_description__oCyeR"};